import React from 'react';
import { MetaText } from "@hm-group/fabric-components/components/Typography";
import cn from 'classnames';
import "./AvailabilityMarker.css";
var styles = { "availability": "ea6341", "hm": "d5de95", "northstar-small": "c2d3a4", "northstar-large": "b747f6" };
const AvailabilityMarker = ({ isOutOfStock, isComingSoon, outOfStockLabel, comingSoonLabel, variant = 'hm', }) => {
    if (!isOutOfStock && !isComingSoon)
        return null;
    const label = isComingSoon ? comingSoonLabel : outOfStockLabel;
    return (React.createElement(MetaText, { Tag: "p", className: cn(styles.availability, styles[variant]), hasEllipsis: true }, label));
};
export default AvailabilityMarker;
//# sourceMappingURL=AvailabilityMarker.js.map